import { render, staticRenderFns } from "./AccountConfirmPhone.vue?vue&type=template&id=c1c48b3a&scoped=true"
import script from "./AccountConfirmPhone.vue?vue&type=script&lang=js"
export * from "./AccountConfirmPhone.vue?vue&type=script&lang=js"
import style0 from "./AccountConfirmPhone.vue?vue&type=style&index=0&id=c1c48b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c48b3a",
  null
  
)

export default component.exports